export default __webpack_public_path__ + "static/media/edit.74d1ddb2.svg";